import Home from '@containers/home';
import { Navigate } from 'react-router-dom';

import Clients from '@containers/clients';
import ClientNew from '@components/client-new';
import ClientDetails from '@containers/client-details';
import TripProfile from '@containers/trip-profile';
import CompositeMap from '@components/composite-map';
import TripProfileForm from '@components/trip-profile-form';
import SurveyGroups from '@containers/survey-layer-groups';
import SurveyLayers from '@containers/survey-layers';
import MapResults from '@components/map-results';
import SelectedDest from '@containers/selected-destination';
import Attractions from '@containers/survey-vibe-attractions';
import Activities from '@containers/survey-vibe-activities';
import TravelStyle from '@containers/survey-vibe-travel-style';
import VoyageVibeResults from '@containers/vibe-results';
import Itinerary from '@containers/itinerary';
import NarrativeInput from '@containers/narrative-input';
import Narratives from '@containers/narratives';
import StaticDashboard from '@components/dashboard-static';
import Settings from '@containers/settings';
import Billing from '@containers/billing';
import BillingAccessPage from '@containers/billing-access';
import Debug from '@containers/debug';

// TODO clean-up or remove
import VibeResultsTable from '@containers/vibe-results-table';

import RouteGuard from './route-guard';
import ErrorPage from './error-page-404';
import protectedAdminRoutes from './protected-admin';
import type { RouteObject } from 'react-router-dom';

const protectedRoutes: RouteObject[] = [
  {
    path: '/',
    element: (
      <RouteGuard>
        <Home />
      </RouteGuard>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Navigate to="/clients" replace />,
      },
      ...protectedAdminRoutes,
      {
        path: 'clients',
        element: (
          <RouteGuard>
            <Clients />
          </RouteGuard>
        ),
      },
      {
        path: 'clients/new',
        element: (
          <RouteGuard>
            <ClientNew />
          </RouteGuard>
        ),
        children: [],
      },
      {
        path: 'clients/:clientId',
        element: (
          <RouteGuard>
            <ClientDetails />
          </RouteGuard>
        ),
        children: [],
      },
      {
        path: 'clients/:clientId/trip-profiles/new',
        element: (
          <RouteGuard>
            <TripProfileForm />
          </RouteGuard>
        ),
      },
      {
        path: 'clients/:clientId/trip-profiles/:tripProfileId/edit',
        element: (
          <RouteGuard>
            <TripProfileForm />
          </RouteGuard>
        ),
      },
      {
        path: 'clients/:clientId/trip-profiles',
        element: (
          <RouteGuard>
            <TripProfile />
          </RouteGuard>
        ),
        children: [
          {
            path: ':tripProfileId',
            element: (
              <RouteGuard>
                <SurveyGroups />
              </RouteGuard>
            ),
          },
          {
            path: ':tripProfileId/composite-map',
            element: (
              <RouteGuard>
                <CompositeMap />
              </RouteGuard>
            ),
          },
          {
            path: ':tripProfileId/layers',
            element: (
              <RouteGuard>
                <SurveyLayers />
              </RouteGuard>
            ),
          },
          {
            path: ':tripProfileId/map-results',
            element: (
              <RouteGuard>
                <MapResults />
              </RouteGuard>
            ),
          },
          {
            path: ':tripProfileId/selected',
            element: (
              <RouteGuard>
                <SelectedDest />
              </RouteGuard>
            ),
          },
          {
            path: ':tripProfileId/vibe-attractions',
            element: (
              <RouteGuard>
                <Attractions />
              </RouteGuard>
            ),
          },
          {
            path: ':tripProfileId/vibe-activities',
            element: (
              <RouteGuard>
                <Activities />
              </RouteGuard>
            ),
          },
          {
            path: ':tripProfileId/vibe-travel-style',
            element: (
              <RouteGuard>
                <TravelStyle />
              </RouteGuard>
            ),
          },
          {
            path: ':tripProfileId/vibe-results',
            element: (
              <RouteGuard>
                <VoyageVibeResults />
              </RouteGuard>
            ),
          },
          {
            path: ':tripProfileId/vibe-results-table',
            element: (
              <RouteGuard>
                <VibeResultsTable />
              </RouteGuard>
            ),
          },
          {
            path: ':tripProfileId/itinerary',
            element: (
              <RouteGuard>
                <Itinerary />
              </RouteGuard>
            ),
          },
          {
            path: ':tripProfileId/narrative-input',
            element: (
              <RouteGuard>
                <NarrativeInput />
              </RouteGuard>
            ),
          },
          {
            path: ':tripProfileId/narratives',
            element: (
              <RouteGuard>
                <Narratives />
              </RouteGuard>
            ),
          },
        ],
      },
      {
        path: 'static-dashboard',
        element: (
          <RouteGuard>
            <StaticDashboard />
          </RouteGuard>
        ),
      },
      {
        path: 'settings',
        element: (
          <RouteGuard>
            <Settings />
          </RouteGuard>
        ),
      },
      {
        path: 'billing',
        element: (
          <RouteGuard>
            <Billing />
          </RouteGuard>
        ),
      },
      {
        path: 'billing-access',
        element: (
          <RouteGuard>
            <BillingAccessPage />
          </RouteGuard>
        ),
      },
      {
        path: '_debug',
        element: (
          <RouteGuard>
            <Debug />
          </RouteGuard>
        ),
      },
    ],
  },
];

export default protectedRoutes;
